export default "__VITE_ASSET__Be3VdNl7__"